<template>
  <div class="modal">
    <TitleFrame :is-modal=true>
      <template slot="contents">
        <ul>
          <li><TextLinkInline text="利用規約" @click-text="onClickKiyaku" /></li>
          <li><TextLinkInline text="プライバシーポリシー" @click-text="onClickPrivacy" /></li>
          <li><TextLinkInline text="お問い合わせ" @click-text="onClickQuestion" /></li>
          <li>システム内ユーザID<br>
            <input type="text" id="input_copy" :value=uid readonly>
            <TextLinkInline text="コピーする" @click-text="onClickCopy" />
          </li>
        </ul>
      </template>
    </TitleFrame>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TitleAndText from '@/components/Atoms/TitleAndText'
import TitleFrame from '@/components/Templates/TitleFrame'
import TextLinkInline from '@/components/Atoms/TextLinkInline'

export default {
  name: 'detail-modal',
  components: {
    TitleAndText,
    TitleFrame,
    TextLinkInline
  },
  computed: {
    ...mapState([
      'uid',
      'selectedSpot',
      'selectedSpotType',
      'originalApiData',
      'selectedSpotRelieved'
    ])
  },
  methods: {
    ...mapMutations([
      'closeModalAll',
      'setDropDestionaton'
    ]),
    onClickCopy () {
      const target = document.getElementById('input_copy')
      if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        target.readOnly = false
        const range = document.createRange()
        range.selectNode(target)
        window.getSelection().addRange(range)
        document.execCommand('copy')
        target.readOnly = true
      } else {
        target.select()
        document.execCommand('copy')
      }
    },
    onClickQuestion (url) {
      window.open('https://forms.gle/oQxhvo91oNpu3igv5', '_blank')
    },
    onClickKiyaku (url) {
      window.open('https://sites.google.com/suisuitabi.org/mitusrules/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84', '_blank')
    },
    onClickPrivacy (url) {
      window.open('https://sites.google.com/suisuitabi.org/mitusrules/%E3%83%97%E3%83%A9%E3%82%A4%E3%83%90%E3%82%B7%E3%83%BC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC', '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
li{
  margin:0.5rem 0rem;
}
input{
  margin: 0rem 1rem 0rem 0rem;
}
.modal{
  background-color: white;
  z-index:1;
  position:absolute;
  width:100%;
  height:100%;
}
.content-area{
  padding:0.3rem;
}
.name-area{
  width:100%;
  display:flex;
}
.title-name {
  width:calc(100% - 4rem);
  font-weight: bold;
  font-size: 1.2rem;
  display:flex;
  align-items: center;
  vertical-align: middle;
}
.ansin-icon {
  margin: 0rem 0rem 0rem 1rem;
  padding:0.2rem;
  border-radius: 0.5rem;
  width:2rem;
  height:3rem;
  text-align:center;
  background-color: hotpink;
}
.ansin-img{
  width:1.5rem;
}
.title-text {
  margin:0.5rem 0rem 0rem 0rem;
  font-weight: bold;
}
.hide{
  visibility: hidden;
}
.review-area{
  width:100%;
  display:flex;
  overflow: scroll;
}
.rev-area{
  align-items: center;
  display: flex;
}
.review{
  width: 10rem;
  height: 10rem;
  margin: 0.2rem 0.5rem;
}
.measure-area{
  width:100%;
  display:flex;
  overflow: scroll;
}
.mes-area{
  align-items: center;
  display: flex;
}
.mes{
  max-width:7rem;
  max-height:6rem;
  margin:0.2rem 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/HelpModal.vue